import { ActionTypes } from "../constants/actionTypes";

const initialState = {
    storage_admin_primaries: { data: null, requestInProgress: false, error: null },
    storage_admin_secondaries: { data: null, requestInProgress: false, error: null },
};

export function storageAdminDataManager(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ADMIN_APPLICATION_PRIMARY_REQUEST:
            return { ...state, storage_admin_primaries: { requestInProgress: true } };
        case ActionTypes.ADMIN_APPLICATION_PRIMARY_SUCCESS:
            return { ...state, storage_admin_primaries: { data: action.storage_admin_primaries, requestInProgress: false } };
        case ActionTypes.ADMIN_APPLICATION_PRIMARY_FAILURE:
            return { ...state, storage_admin_primaries: { requestInProgress: false, error: action.error } };
        case ActionTypes.ADMIN_APPLICATION_SECONDARY_REQUEST:
            return { ...state, storage_admin_secondaries: { requestInProgress: true } };
        case ActionTypes.ADMIN_APPLICATION_SECONDARY_SUCCESS:
            return { ...state, storage_admin_secondaries: { data: action.storage_admin_secondaries, requestInProgress: false } };
        case ActionTypes.ADMIN_APPLICATION_SECONDARY_FAILURE:
            return { ...state, storage_admin_secondaries: { requestInProgress: false, error: action.error } };
        default:
            return state;
    }
}